import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import GetLand from "../api/land/GetLand";
import MapPolygonViewer from "./GoogleMapPolygonView";
import GetFarm from "../api/farm/GetFarm";
import MapMarkerViewer from "./GoogleMapPinView";
import GetFarmer from "../api/farmer/GetFarmer";
import CreateRent from "../api/rent/CreateRent";
import GetRent from "../api/rent/GetRent";
import DeleteRent from "../api/rent/DeleteRent";
import GetAllRent from "../api/rent/GetAllRent";
import GetAllFarm from "../api/farm/GetAllFarm";
import GetAllLand from "../api/land/GetAllLand";
import GetAllFarmer from "../api/farmer/GetAllFarmer";
const Appointment = () => {
  const theme = useTheme();
  const getStatusColor = (status) => {
    switch (status) {
      case "รอการตรวจสอบ":
        return "orange";
      case "พ่นยาสำเร็จ":
        return "green";
      case "ยกเลิก":
        return "red";
      case "รอคิวพ่นยา":
        return "gold";
      default:
        return "inherit";
    }
  };
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [farms, setFarms] = useState([]);
  const [farmer, setFarmer] = useState([]);
  const [rows, setRows] = useState([]);
  const [landPolygons, setLandPolygons] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const defaultRole = userData.level === 1 ? "admin" : "user";
  const [role] = useState(defaultRole);
  const [appointments, setAppointments] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [confirmDelete, setConfirmDelete] = useState({ open: false, appRentId: null });
  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    date: "",
    time: "",
    medicine: "ไม่มียา",
    appLandId: "",
    appRentId: "",
    appFarmerId: "",
    appFarmId: ""
  });
  const timestamp = Math.floor(Date.now() / 1000);
  function convertToRows(data) {
    return data.map((item, index) => {
      const avgLat = item.lat.reduce((sum, val) => sum + val, 0) / item.lat.length;
      const avgLon = item.lon.reduce((sum, val) => sum + val, 0) / item.lon.length;
      return {
        id: index + 1,
        type: item.landType,
        number: item.appLandId,
        lat: avgLat.toFixed(6),
        long: avgLon.toFixed(6),
        rai: item.noOfRais,
        ngan: item.noOfNgan,
        wa: item.noOfWah,
        appLandId: item.appLandId,
      };
    });
  }

  function convertToPolygons(data) {
    return data.map((item) => {
      const coordinates = item.lat.map((latVal, i) => ({
        lat: latVal,
        lng: item.lon[i],
      }));
      return {
        areaType: item.landType,
        coordinates,
        appLandId: item.appLandId,
      };
    });
  }

  const handleOpen = (row) => {
    if (row) {
      setSelected(row);
      setFormData({
        name: row.name || "",
        mobileNo: row.mobileNo,
        date: row.date || "",
        time: row.time || "",
        medicine: row.medicine || "ไม่มีน้ำยา",
        appLandId: row.appLandId || "",
        appRentId: row.appRentId || "",
        appFarmId: row.appFarmId || "",
        appFarmerId: row.appFarmerId || "",
        status: row.status || ""
      });
    } else {
      setSelected(null);
      setFormData({
        name: farmer.title + " " + farmer.firstName + " " + farmer.lastName,
        mobileNo: farmer.mobileNo,
        date: "",
        time: "",
        medicine: "ไม่มีน้ำยา",
        appLandId: "",
        appFarmId: "",
        appRentId: "RE" + timestamp,
        appFarmerId: userData.appFarmerId,
        status: "รอการตรวจสอบ"
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };

  const handleSave = async () => {
    if (!formData.name || !formData.date || !formData.time) {
      setSnackbar({ open: true, message: "กรุณากรอกข้อมูลให้ครบถ้วน", severity: "error" });
      return;
    }

    const newAppRentId = formData.appRentId || "RE" + timestamp;

    if (selected) {
      setAppointments((prev) =>
        prev.map((item) =>
          item.appRentId === newAppRentId ? { ...item, ...formData, appRentId: newAppRentId } : item
        )
      );
      await CreateRent(formData);
      setSnackbar({ open: true, message: "แก้ไขข้อมูลเรียบร้อยแล้ว", severity: "success" });
    } else {

      setAppointments((prev) => [
        ...prev,
        { ...formData, appRentId: newAppRentId },
      ]);
      await CreateRent(formData);
      setSnackbar({ open: true, message: "เพิ่มข้อมูลเรียบร้อยแล้ว", severity: "success" });
    }


    setOpen(false);
  };

  const handleDelete = (appRentId) => {
    setConfirmDelete({ open: true, appRentId });
  };

  const fetchLandData = useCallback(async () => {
    if (userData?.registor === 1) {
      try {
        let response1 = []
        let response2 = []
        let response3 = []
        let response4 = []
        if (role === "admin") {
          response1 = await GetAllLand({ appFarmerId: userData.appFarmerId });
          response2 = await GetAllFarm({ appFarmerId: userData.appFarmerId });
          response3 = await GetAllFarmer({ appFarmerId: userData.appFarmerId });
          response4 = await GetAllRent({ appFarmerId: userData.appFarmerId });
        } else {
          response1 = await GetLand({ appFarmerId: userData.appFarmerId });
          response2 = await GetFarm({ appFarmerId: userData.appFarmerId });
          response3 = await GetFarmer({ appFarmerId: userData.appFarmerId });
          response4 = await GetRent({ appFarmerId: userData.appFarmerId });
        }
        setRows(convertToRows(response1));
        setLandPolygons(convertToPolygons(response1));
        setFarms(response2);
        setFarmer(response3);
        setAppointments(response4)
      } catch (error) {
        console.error("Error fetching farmer data:", error);
      }
    }
  }, [userData]);

  useEffect(() => {
    fetchLandData();
  }, []);
  const confirmDeleteAppointment = async () => {
    setAppointments((prev) =>
      prev.filter((item) => item.appRentId !== confirmDelete.appRentId)
    );
    await DeleteRent({ appRentId: confirmDelete.appRentId });
    setSnackbar({ open: true, message: "ลบข้อมูลเรียบร้อยแล้ว", severity: "error" });
    setConfirmDelete({ open: false, appRentId: null });
    handleClose();
  };


  const columns = [
    {
      field: "status",
      headerName: "สถานะ",
      flex: 1,
      renderCell: (params) => (
        <span style={{ color: getStatusColor(params.value), fontWeight: "bold" }}>
          {params.value}
        </span>
      ),
    },
    { field: "date", headerName: "วันนัดหมาย", flex: 1 },
    { field: "time", headerName: "เวลา", flex: 1 },
    {
      field: "actions",
      headerName: "ตรวจสอบ",
      renderCell: (params) => (
        <Button variant="outlined" onClick={() => handleOpen(params.row)}>
          แก้ไข
        </Button>
      ),
    },
  ];


  return (
    <Box p={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">จัดการนัดหมาย</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen(null)}>
          เพิ่มนัดหมาย
        </Button>
      </Box>

      <DataGrid
        rows={appointments}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        getRowId={(row) => row.appRentId}
      />


      <Dialog open={open} onClose={handleClose} fullWidth scroll="body" fullScreen={fullScreen}>
        <DialogTitle>{selected ? "แก้ไขนัดหมาย" : "เพิ่มนัดหมาย"}</DialogTitle>

        <DialogContent>
        {role === "admin" ? (
  <FormControl fullWidth margin="normal">
    <InputLabel id="status-label">สถานะ</InputLabel>
    <Select
      labelId="status-label"
      value={formData.status}
      label="สถานะ"
      onChange={(e) =>
        setFormData((prev) => ({ ...prev, status: e.target.value }))
      }
      sx={{ color: getStatusColor(formData.status) }}
    >
      <MenuItem value="รอการตรวจสอบ">รอการตรวจสอบ</MenuItem>
      <MenuItem value="รอคิวพ่นยา">รอคิวพ่นยา</MenuItem>
      <MenuItem value="พ่นยาสำเร็จ">พ่นยาสำเร็จ</MenuItem>
      <MenuItem value="ยกเลิก">ยกเลิก</MenuItem>
    </Select>
  </FormControl>
) : (
  <TextField
    fullWidth
    margin="normal"
    label="สถานะ"
    value={formData.status}
    InputProps={{
      readOnly: true,
      sx: { color: getStatusColor(formData.status) },
    }}
  />
)}

          <FormControl fullWidth margin="normal">
            <InputLabel id="farm-select-label">เลือกฟาร์ม</InputLabel>
            <Select
              labelId="farm-select-label"
              value={formData.appFarmId}
              label="เลือกฟาร์ม"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  appFarmId: e.target.value,
                }))
              }
            >
              {farms.map((farm) => (
                <MenuItem key={farm.appFarmId} value={farm.appFarmId}>
                  {`${farm.province} - ${farm.amphur} - ${farm.tambon}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {formData.appFarmId && (
            <Box mt={2} height="300px">
              <MapMarkerViewer
                payload={farms.filter((f) => f.appFarmId === formData.appFarmId)}
              />
            </Box>
          )}
          <FormControl fullWidth margin="normal">
            <InputLabel id="land-select-label">เลือกแปลงที่ดิน</InputLabel>
            <Select
              labelId="land-select-label"
              value={formData.appLandId}
              label="เลือกแปลงที่ดิน"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  appLandId: e.target.value,
                }))
              }
            >
              {rows.map((row) => (
                <MenuItem key={row.appLandId} value={row.appLandId}>
                  {row.type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {formData.appLandId && (
            <Box mt={2} height="300px">
              <MapPolygonViewer polygons={landPolygons.filter((p) => p.appLandId === formData.appLandId)} />
            </Box>

          )}
          {formData.appLandId && (
            <TextField
              fullWidth
              margin="normal"
              label="ขนาดพื้นที่"
              value={
                (() => {
                  const land = rows.find((p) => p.appLandId === formData.appLandId);
                  return land
                    ? `${land.rai} ไร่ ${land.ngan} งาน ${land.wa} วา`
                    : "";
                })()
              }
              InputProps={{ readOnly: true }}
            />

          )}

          <TextField
            fullWidth
            margin="normal"
            label="ชื่อ-นามสกุล"
            value={
              role === "admin"
                ? formData.name
                : `${farmer.title} ${farmer.firstName} ${farmer.lastName}`
            }
            onChange={
              role === "admin"
                ? (e) => setFormData((prev) => ({ ...prev, name: e.target.value }))
                : undefined
            }
            InputProps={{ readOnly: true }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="เบอร์โทรศัพท์"
            value={
              role === "admin"
                ? formData.mobileNo
                : `${farmer.mobileNo}`
            }
            onChange={(e) => setFormData((prev) => ({ ...prev, mobileNo: e.target.value }))
            }
            InputProps={{ readOnly: true }}
          />


          <TextField
            fullWidth
            margin="normal"
            label="วันนัดหมาย"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={formData.date}
            onChange={(e) => setFormData((prev) => ({ ...prev, date: e.target.value }))}
          />
          <TextField
            fullWidth
            margin="normal"
            label="เวลา"
            type="time"
            InputLabelProps={{ shrink: true }}
            value={formData.time}
            onChange={(e) => setFormData((prev) => ({ ...prev, time: e.target.value }))}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="hasMedicine-label">การพ่นยา</InputLabel>
            <Select
              labelId="hasMedicine-label"
              value={formData.medicine}
              label="การให้ยา"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  medicine: e.target.value,
                }))
              }
            >
              <MenuItem value="มียา">มียาอยู่แล้ว</MenuItem>
              <MenuItem value="ไม่มียา">ไม่มียา</MenuItem>
            </Select>
          </FormControl>

          {selected && (
            <Box mt={2}>
              <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => handleDelete(selected.appRentId)}
              >
                ลบนัดหมาย
              </Button>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>ยกเลิก</Button>
          <Button onClick={handleSave} variant="contained">
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDelete.open}
        onClose={() => setConfirmDelete({ open: false, appRentId: null })}
        fullScreen={fullScreen}
        scroll="body"
        fullWidth
      >
        <DialogTitle>ยืนยันการลบ</DialogTitle>
        <DialogContent>
          <Typography>คุณแน่ใจหรือไม่ว่าต้องการลบนัดหมายนี้?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete({ open: false, appRentId: null })}>ยกเลิก</Button>
          <Button onClick={confirmDeleteAppointment} variant="contained" color="error">
            ลบ
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Appointment;